import PropTypes from 'prop-types';
import { Stack, Grid } from '@mui/material';

const SelectedTitleColumns = (
  {
    column1,
    column2,
    column3,
    column4,
    column5,
    column6,
    column7
  }
) => {

  return (
    <Grid container sx={{ flexGrow: 1 }} spacing={4}>
      <Grid className="column1" size={4}>{column1}</Grid>
      <Grid className="column2" size={1}><Stack justifyContent="center" alignItems="center" sx={{ height: '100%' }}>{column2}</Stack></Grid>
      <Grid className="column3" size={1}><Stack justifyContent="center" sx={{ height: '100%' }}>{column3}</Stack></Grid>
      <Grid className="column4" size={1.7}><Stack justifyContent="center" sx={{ height: '100%' }}>{column4}</Stack></Grid>
      <Grid className="column5" size={1.1}><Stack justifyContent="center" sx={{ height: '100%' }}>{column5}</Stack></Grid>
      <Grid className="column6" size={1}><Stack justifyContent="center" sx={{ height: '100%' }}>{column6}</Stack></Grid>
      <Grid className="column7" size={2.2}>{column7}</Grid>
    </Grid>
  );
};

SelectedTitleColumns.propTypes = {
  column1: PropTypes.node.isRequired,
  column2: PropTypes.node.isRequired,
  column3: PropTypes.node.isRequired,
  column4: PropTypes.node.isRequired,
  column5: PropTypes.node.isRequired,
  column6: PropTypes.node.isRequired,
  column7: PropTypes.node.isRequired
};

SelectedTitleColumns.defaultProps = {
};

export default SelectedTitleColumns;
